import { FormTranslationType, Language } from '@seaters/constants';
import { getObjectTranslation } from '../getObjectTranslation/getObjectTranslation';

/**
 * Same lookup as {@link getObjectTranslation}, but always resolves to a string.
 *
 * Use it wherever the result is rendered or interpolated (image `alt`, `t()`
 * variables), since `null` leaks into those as a missing attribute or the
 * literal "null".
 *
 * The map itself is optional on purpose: the Java fan views only emit
 * `eventName` / `venueName` when the waiting list actually has a linked event or
 * venue (see `WaitingListForFanHolder2WaitingListForFanDTOConverter`), so an
 * experience without an event arrives with the key missing entirely.
 */
export const getMapTranslation = (
  data: FormTranslationType | null | undefined,
  lang?: Language | string
): string => getObjectTranslation(data, lang ?? Language.EN) ?? '';
